import { useEffect, useRef } from 'react'
import { router } from '@inertiajs/react'
import { createConsumer } from '@rails/actioncable'

let cable: ReturnType<typeof createConsumer> | null = null
function getCable() {
  if (!cable) cable = createConsumer()
  return cable
}

/**
 * Subscribe to the SyncChannel and reload the page when a matching
 * resource change is broadcast from another window/session.
 *
 * @param resource - The resource type to listen for (e.g. "notes", "boards", "tasks")
 */
export function useSync(resource: string) {
  const reloadTimeout = useRef<ReturnType<typeof setTimeout>>()

  useEffect(() => {
    const subscription = getCable().subscriptions.create(
      { channel: 'SyncChannel' },
      {
        received(data: { resource: string; action: string }) {
          if (data.resource === resource || (resource === 'boards' && data.resource === 'tasks')) {
            // Debounce rapid successive events
            if (reloadTimeout.current) clearTimeout(reloadTimeout.current)
            reloadTimeout.current = setTimeout(() => {
              router.reload({ preserveScroll: true })
            }, 300)
          }
        },
      }
    )

    return () => {
      if (reloadTimeout.current) clearTimeout(reloadTimeout.current)
      subscription.unsubscribe()
    }
  }, [resource])
}
